






// 接入请求数据
import {unit,add,update,del,status} from "../../request/api/appletset/unit.js"

// 接入请求数据
const state ={
	
};
const getters = {

}
const mutations ={

	
};
const actions ={
	// getunit
	async getunit(content,payload){
		let {data:data} = await unit({
			page:payload.current,
			pageSize:payload.pageSize,
			keyword:payload.keyword,
		});
		return data
	},
	// update
	async getupdate(content,payload){
		let {msg:msg} = await update({
			id:payload.id,
			name:payload.name,
		});
		return msg
	},
	// add
	async getadd(content,payload){
		let {msg:msg} = await add({
			name:payload.name,
		});
		return msg
	},
	// del
	async getdel(content,payload){
		let {msg:msg} = await del({
			id:payload,
		});
		return msg
	},
};

export default {
	namespaced: true,   //使用命名空间

	state,
	
	getters,

	mutations,

	actions
}
